import { colors, fonts } from 'components/styles/variables';
import css from 'styled-jsx/css';

export default css`
  .budget-step-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 564px;
    justify-content: space-between;
    width: 295px;
  }
  .budget-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .input-slider-block-container {
    width: 295px;
  }
  .slider-container {
    width: 295px;
  }
  .header {
    text-align: center;
    font-family: ${fonts.default};
    font-weight: 700;
    font-size: 22px;
    line-height: 32px;
    letter-spacing: 0.2px;
    margin-bottom: 20px;
  }
  .subtitle {
    text-align: center;
    font-family: ${fonts.default};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.G3};
    margin-bottom: 64px;
  }
`;
